((app, ng) => {
    //
    // Md-dialog's "this" refers to the window instead of the an
    // isolated scope. So we'll set $ctrl to an empty object instead 
    // to keep the template naming convention intact.
    //
    app.controller("additionalDetailCtrl", ["$scope", "$mdDialog", "$filter", "payload",
        ($scope, $mdDialog, $filter, payload) => {
        let $ctrl = {};
        $scope.$ctrl = $ctrl;
        $ctrl.isArray = ng.isArray;

        $ctrl.$onInit = async () => {
            $ctrl.title = payload.title;
            $ctrl.data = payload.data;
        };
        $ctrl.$onInit();

        $ctrl.close = () => {
            $mdDialog.cancel();
        };

        $ctrl.getKeys = function (object) {
            return Object.keys(object).filter(key => !key.includes("$$"));
        };

        $ctrl.deCamelize = function (term) {
            return term.replace(/([A-Z])/g, ' $1').trim();
        };

        $ctrl.NumOrGrouping = function (key) {
            if (key === 'Num' || key === 'Grouping') {
                return true;
            }
            return false;
        };

        $ctrl.reformat = function (key, val) {
            if (key.includes('On') || key.includes('Date') || key.includes('Dob')) {
                return $filter('date')(val);
            }
            else if (/(percent)/i.test(key) && val) {
                return val + "%";
            }
            else if (typeof val === "number" && key.includes('Value') && !key.includes('Amount')) {
                return $filter('currency')(val);
            }
            return val;
        };
    }]);
})(window.app, window.angular);
